import React from 'react';
import PropTypes from 'prop-types';
import Body from '@redturtle/volto-io-prenoto/components/Blocks/BookingButton/Body';

const View = (props) => {
  return (
    <div className="block booking-button">
      <Body {...props} />
    </div>
  );
};

View.propTypes = {
  data: PropTypes.objectOf(PropTypes.any).isRequired,
};

export default View;
